import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

function getVisitorId(): string {
  let id = localStorage.getItem("wavai_visitor_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("wavai_visitor_id", id);
  }
  return id;
}

const EXCLUDED_PREFIXES = ["/admin", "/api", "/auth", "/_next", "/static"];

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Skip tracking for admin and system routes
    if (EXCLUDED_PREFIXES.some((p) => location.pathname.startsWith(p))) return;

    const visitorId = getVisitorId();
    supabase.from("page_views").insert({
      page_path: location.pathname,
      visitor_id: visitorId,
      referrer: document.referrer || null,
    } as any).then(() => {});
  }, [location.pathname]);
}

export function trackBlogView(slug: string, postId?: string) {
  const visitorId = getVisitorId();
  supabase.from("blog_views").insert({
    slug,
    post_id: postId || null,
    visitor_id: visitorId,
    referrer: document.referrer || null,
  } as any).then(() => {});
}
